<template>
    <v-row dense>
        <v-col cols="12" md="4">
            <v-select
                v-model="selectedInstitute"
                :items="institutes"
                item-title="name"
                item-value="id"
                return-object
                label="Select Institute"
                variant="outlined"
                prepend-inner-icon="mdi-domain"
                density="comfortable"
                hide-details
                rounded="lg"
                @update:model-value="loadInstituteData"
            />
        </v-col>
        <v-col cols="12" md="4">
            <v-text-field v-model="search" variant="outlined" prepend-inner-icon="mdi-magnify" label="Search" density="comfortable" hide-details rounded="lg" />
        </v-col>
        <v-col cols="12">
            <v-card class="dt-container mt-2">
                <v-data-table :mobile="isMobileOrTablet()" :headers="headers" :items="tableItems" :search="search" :loading="loading" :items-per-page="15" :items-per-page-options="[15, 30, 50, 100, -1]">
                    <template v-slot:loading><v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg" /></template>
                    <template v-slot:item.submittedBy="{ item }">{{ item.submittedBy }}</template>
                    <template v-slot:item.latestSubmissionDate="{ item }">{{ formatDate(item.latestSubmissionDate) }}</template>
                        <template v-slot:[`item.action`]="{ item }">
                        <v-btn size="small" @click="showDialog(item)" variant="outlined" text="View Uploads" color="green-accent-4" elevation="2" />
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>
    <VPAAUploadedComplianceDialog ref="dialog" />
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import VPAAUploadedComplianceDialog from '../Dialogs/VPAAUploadedComplianceDialog.vue';

export default defineComponent({
    components: { VPAAUploadedComplianceDialog },
    data() {
        return {
            data: [],
            search: null,
            loading: false,
            compliance: null,
            institutes: [],
            selectedInstitute: null,
            headers: [
                { title: 'Faculty Name', align: 'start', sortable: true, key: 'submittedBy' },
                { title: 'Program/Department', align: 'start', sortable: true, key: 'user.program.abbrev' },
                { title: 'Submission Count', align: 'start', sortable: true, key: 'submissionCount' },
                { title: 'Total Course Load', align: 'start', sortable: true, key: 'totalFacultyLoad' },
                { title: 'Latest Submission Date', align: 'start', sortable: true, key: 'latestSubmissionDate' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' }
            ]
        };
    },
    computed: {
        tableItems() {
            return this.data.map((d) => ({
                ...d,
                submittedBy: `${d.user?.fname ?? ''} ${d.user?.lname ?? ''}`.trim()
            }));
        }
    },
    methods: {
        init(compliance) {
            this.compliance = compliance;
            const token = localStorage.getItem('aums-token');
            this.loading = true;
            axios.get(process.env.VUE_APP_SERVER_URL + '/offices/getAllInstituteAndExternalCampus', {
                headers: { Authorization: `Bearer ${token}` }
            }).then((res) => {
                this.institutes = res.data || [];
                this.selectedInstitute = this.institutes[0] || null;
                return this.loadInstituteData();
            }).catch((error) => {
                if (error.response?.status === 401) {
                    localStorage.removeItem('vuex');
                    localStorage.removeItem('aums-token');
                    window.location.reload();
                } else {
                    console.error(error);
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        loadInstituteData() {
            if (!this.selectedInstitute || !this.compliance) {
                this.data = [];
                return Promise.resolve();
            }

            const token = localStorage.getItem('aums-token');
            this.loading = true;
            return axios.get(process.env.VUE_APP_SERVER_URL + '/compliance-upload-details/findAllCompliancesDetailsByInstituteAndSemester/' + this.selectedInstitute.id + '/' + this.compliance.id + '/' + this.$store.state.semester_schoolyear.id, {
                headers: { Authorization: `Bearer ${token}` }
            }).then((res) => {
                this.data = res.data || [];
            }).catch((error) => {
                if (error.response?.status === 401) {
                    localStorage.removeItem('vuex');
                    localStorage.removeItem('aums-token');
                    window.location.reload();
                } else {
                    console.error(error);
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        showDialog(item) {
            this.$refs.dialog.init(item.user, this.compliance);
        }
    }
});
</script>
